import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { IRBData } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetRBData = (
  locationCode: string,
  versionId: string,
  enabled = true,
) => {
  const filters = [`location_code=${locationCode}`, `version_id=${versionId}`];

  return useQuery({
    queryKey: queryKeys.rbDataVersion.details(filters),
    queryFn: () => fetchRBData(filters),
    enabled: enabled && !isEmpty(filters),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};

const fetchRBData = async (filters: string[] = []) => {
  const query = generateQuery([], filters);

  const url = `/rbDataVersion${query}`;

  const response = await requestCCApi({ url });

  return response as IRBData;
};
